import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';
import AESLogo from '../../assets/AES_short_white.svg';
import SPLogo from '../../assets/SP_Logo.svg';

const TopNavbar = ({menuTitle}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user, logout} = useAuth();
    const [showLogout, setShowLogout] = useState(false);
    const logoutRef = useRef(null);

    const handleLogout = () => {
        logout();
        navigate('/login',{ replace: true });
    };


    const toggleLogout = () => {
        setShowLogout(!showLogout);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (logoutRef.current && !logoutRef.current.contains(event.target)) {
                setShowLogout(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [logoutRef]);

    return (
        <div className="shadow-lg bg-gradient-to-br from-gray-800 via-gray-900 to-black pb-4 pt-4 border-b border-gray-700">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        {location.pathname !== '/dashboard' ? (
                            <button
                                onClick={() => navigate('/dashboard')}
                                className="text-2xl flex items-center ml-4 text-gray-300 hover:text-gray-100 transition-colors duration-150"
                                style={{ width: '2.5rem', height: '2.5rem' }}
                            >
                                <svg
                                    className="w-6 h-6 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M15 19l-7-7 7-7"
                                    ></path>
                                </svg>
                            </button>
                        ) : (
                            <div className="text-2xl flex items-center" style={{ width: 0, height: 0 }}></div>
                        )}
                        <div className="text-gray-200 text-2xl font-bold ml-4">{menuTitle}</div>
                    </div>
                    <div className="flex items-center space-x-4 relative">
                        <button
                            onClick={toggleLogout}
                            className="text-gray-300 hover:text-gray-100 text-2xl flex items-center transition duration-150"
                        >
                            <svg
                                className="w-6 h-6 mr-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                ></path>
                            </svg>
                            {user.username}
                        </button>
                        {showLogout && (
                            <div
                                ref={logoutRef}
                                className="absolute top-full mt-2 right-0 bg-gradient-to-br from-gray-700 to-gray-800 shadow-xl rounded p-2 z-50"
                            >
                                <button
                                    onClick={handleLogout}
                                    className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded transition duration-150 ease-in-out"
                                >
                                    Logout
                                </button>
                            </div>
                        )}
                        <img src={AESLogo} alt="SP Logo" className="h-16 w-16"/>
                    </div>
                </div>
            </div>
        </div>

    )
        ;
};

export default TopNavbar;